import inView from 'kudago-in-view/src/in-view';
import breakpoint from './breakpoint.js';

export default class InViewHandler {
    constructor() {
        const menuItems = document.querySelectorAll(
            '.w-menu--header .menu-item'
        );

        const inviewBlock = inView();
        const blockOffset = ['xs', 'sm'].includes(breakpoint.breakpoint)
            ? 100
            : 250;
        inviewBlock.offset(blockOffset);
        inviewBlock('.w-b').on('enter', (el) => {
            el.classList.add('w-is-in-view');

            const anchor = el.querySelector('.w-b__anchor[id]');
            if (anchor) {
                const menuItem = document.querySelector(
                    `a[href$="#${anchor.id}"]`
                );
                if (menuItem) {
                    menuItems.forEach(function (item) {
                        item.classList.remove('w-is-current');
                    });
                    menuItem.parentElement.classList.add('w-is-current');
                }
            }
        });

        const inviewLottie = inView();
        inviewLottie.threshold(1);
        inviewLottie('[data-w-lottie]').on('enter', (el) => {
            const event = new CustomEvent('w.InViewHandler.enterLottie', {
                detail: el,
            });
            document.dispatchEvent(event);
        });

        const inviewGeneral = inView();
        inviewGeneral.threshold(1);
        inviewGeneral('[data-w-inview]').on('enter', (el) => {
            el.classList.add('w-is-in-view');
        });
    }
}
